export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        templates: action.templates,
      };
    case 'MOVE':
      return {
        ...state,
        templates: action.templates,
      };
    case 'UPDATE':
      return {
        ...state,
        templates: state.templates.map((item) => (item.id === action.template.id ? action.template : item)),
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
